import { API } from '@/api';
import { fetcher, HTTPError } from '@/services/fetcher';

import { accessorialApiSchema, availableAccessorialCodesApiSchema } from '../../models';
import { logger } from '../../utils/logger';

const pricing = fetcher.extend(() => ({ prefixUrl: `${API.BASE_PRICING}` }));
const accessorial = fetcher.extend(() => ({ prefixUrl: API.ACCESSORIALS }));

export const fetchAccessorial = async (
  { accessorialKey }: { accessorialKey: number },
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await accessorial
      .get(`${accessorialKey}`, {
        signal,
      })
      .json(accessorialApiSchema);
  } catch (error) {
    if (error instanceof HTTPError) {
      logger.error(`Accessorial error: ${error.response.status}`);
    }
    throw error;
  }
};

export const fetchAvailableAccessorialCodes = async ({ signal }: { signal?: AbortController['signal'] } = {}) => {
  try {
    return await pricing
      .get('options/$available-accessorial-codes', { signal })
      .json(availableAccessorialCodesApiSchema);
  } catch (error) {
    if (error instanceof HTTPError) {
      logger.error(`Available accessorial codes error: ${error.response.status}`);
    }
    throw error;
  }
};
